// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uq0hGCyA5qkea8PsEBPm, .uq0hGCyA5qkea8PsEBPm tr, .uq0hGCyA5qkea8PsEBPm th {
    margin: 0;
    padding: 0;
    border-bottom: 1px solid #EDEDED;
    vertical-align: middle;
}

.uq0hGCyA5qkea8PsEBPm td{
    padding-right: 5px;
    padding-left: 5px;
    border: 1px solid #EDEDED;

}

.uq0hGCyA5qkea8PsEBPm {
    width: 100%;
    background-color: transparent;
    border-collapse: collapse;
    border-spacing: 0;
}

    /* Heading */

.uq0hGCyA5qkea8PsEBPm th {
    padding: 11px 15px 15px 5px;
    font-size: 14px;
    font-weight: 600;
    color: hc-secondary;
    text-transform: uppercase;
    user-select: none;
    padding-top: 35px;
}

.uq0hGCyA5qkea8PsEBPm .c2VGruMn7eO9vcCQI1gw {
    position: relative;
}

.Cr2rkTnk98OKyhsXbzZU {
    align-items: center;
    display: flex;
    justify-content: flex-end;
}

.Cr2rkTnk98OKyhsXbzZU > .a0q0RyX9Xvmu0lAKskVQ + .a0q0RyX9Xvmu0lAKskVQ {
    margin-left: 16px;
}

.uq0hGCyA5qkea8PsEBPm .c2VGruMn7eO9vcCQI1gw i {
    position: absolute;
    top: -1px;
    left: 3px;
}

.uq0hGCyA5qkea8PsEBPm .EcBuN5J34gLVIl_Q4oHZ {
    position: relative;
}

.uq0hGCyA5qkea8PsEBPm .EcBuN5J34gLVIl_Q4oHZ i {
    position: absolute;
    top: 6px;
    left: 3px;
}

.asHOdaSlWmmSV_b9tTfV {
    align-items: flex-start;
    display: flex;
    justify-content: space-between;
}

.rfYheExatBX_G5Anx6Ae {
    margin-bottom: 0;
}

.KuhjdLiOASpMna7Sr298 {
    display: flex;
    flex: 1;
}

.Cr2rkTnk98OKyhsXbzZU {
    align-items: center;
    display: flex;
    justify-content: flex-end;
}

.Cr2rkTnk98OKyhsXbzZU > .a0q0RyX9Xvmu0lAKskVQ + .a0q0RyX9Xvmu0lAKskVQ {
    margin-left: 16px;
}

.MXJ_sNVQZRZZqQNdgM8k {
    padding: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/settings/pages/team/team-table.module.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;;AAE7B;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,yBAAyB;IACzB,iBAAiB;AACrB;;IAEI,YAAY;;AAEhB;IACI,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,OAAO;AACX;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".table, .table tr, .table th {\n    margin: 0;\n    padding: 0;\n    border-bottom: 1px solid #EDEDED;\n    vertical-align: middle;\n}\n\n.table td{\n    padding-right: 5px;\n    padding-left: 5px;\n    border: 1px solid #EDEDED;\n\n}\n\n.table {\n    width: 100%;\n    background-color: transparent;\n    border-collapse: collapse;\n    border-spacing: 0;\n}\n\n    /* Heading */\n\n.table th {\n    padding: 11px 15px 15px 5px;\n    font-size: 14px;\n    font-weight: 600;\n    color: hc-secondary;\n    text-transform: uppercase;\n    user-select: none;\n    padding-top: 35px;\n}\n\n.table .headingCellDesc {\n    position: relative;\n}\n\n.buttons {\n    align-items: center;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.buttons > .button + .button {\n    margin-left: 16px;\n}\n\n.table .headingCellDesc i {\n    position: absolute;\n    top: -1px;\n    left: 3px;\n}\n\n.table .headingCellAsc {\n    position: relative;\n}\n\n.table .headingCellAsc i {\n    position: absolute;\n    top: 6px;\n    left: 3px;\n}\n\n.header {\n    align-items: flex-start;\n    display: flex;\n    justify-content: space-between;\n}\n\n.title {\n    margin-bottom: 0;\n}\n\n.container {\n    display: flex;\n    flex: 1;\n}\n\n.buttons {\n    align-items: center;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.buttons > .button + .button {\n    margin-left: 16px;\n}\n\n.card {\n    padding: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `uq0hGCyA5qkea8PsEBPm`,
	"headingCellDesc": `c2VGruMn7eO9vcCQI1gw`,
	"buttons": `Cr2rkTnk98OKyhsXbzZU`,
	"button": `a0q0RyX9Xvmu0lAKskVQ`,
	"headingCellAsc": `EcBuN5J34gLVIl_Q4oHZ`,
	"header": `asHOdaSlWmmSV_b9tTfV`,
	"title": `rfYheExatBX_G5Anx6Ae`,
	"container": `KuhjdLiOASpMna7Sr298`,
	"card": `MXJ_sNVQZRZZqQNdgM8k`
};
export default ___CSS_LOADER_EXPORT___;
